import React, { useEffect, useState, createContext } from 'react'

import { RunDetailsProps } from './RunDetails.types'
import './RunDetails.scss'
import RunContent from './RunContent'

export const CardContext = createContext(null)

export const RunDetails: React.FC<RunDetailsProps> = ({
  projectName,
  projectOwner,
  run, // Cloud and Local
  client,
  style,
  getFileCard,
  getFolderCard,
  isCloud=true,
  fileCardConfig=undefined
}) => {

  const [extraInputs, setExtraInputs] = useState<any[]>([])
  const [recipeInputs, setRecipeInputs] = useState<any[]>([])
  const [outputs, setOutputs] = useState<any[]>([])

  useEffect(() => {
    if (!run) return

    let recipeInputNames = [] as string[]
  
    if (run.recipe && run.recipe.inputs) {
      recipeInputNames = run.recipe.inputs.map(i => i.name)
    }
  
    const outputs = [] as any[]
    const recipeInputs = [] as any[]
    const extraInputs = [] as any[]

    if (run.status) {
      run.status.inputs.forEach(i => {
        if (recipeInputNames.includes(i.name)) {
          recipeInputs.push(i)
        } else {
          extraInputs.push(i)
        }
      })
      run.status.outputs.map(o => outputs.push(o))
    }
  
    setExtraInputs(extraInputs)
    setRecipeInputs(recipeInputs)
    setOutputs(outputs)
  }, [run])

  return (
    <CardContext.Provider value={fileCardConfig}>
      <div>
        {outputs &&
          <RunContent 
            title={'Outputs'}
            inputData={outputs}
            projectName={projectName}
            projectOwner={projectOwner}
            run={run}
            client={client}
            style={style}
            getFileCard={getFileCard}
            getFolderCard={getFolderCard}
            isCloud={isCloud}
        />}

        {recipeInputs &&
          <RunContent 
            title={'Inputs'}
            inputData={recipeInputs}
            projectName={projectName}
            projectOwner={projectOwner}
            run={run}
            client={client}
            style={style}
            getFileCard={getFileCard}
            getFolderCard={getFolderCard}
            isCloud={isCloud}
            isOpen={false}
        />}

        {extraInputs && extraInputs.length > 0 && 
          <RunContent 
            title={'Extra Inputs'}
            inputData={extraInputs}
            projectName={projectName}
            projectOwner={projectOwner}
            run={run}
            client={client}
            style={style}
            getFileCard={getFileCard}
            getFolderCard={getFolderCard}
            isCloud={isCloud}
            isOpen={false}
        />}
      </div>
    </CardContext.Provider>
  )
}

export default RunDetails

